// extracted by mini-css-extract-plugin
export default {"CreateBadges":"CreateBadges_CreateBadges__EXDrH"};